import { createContext, useContext } from 'react'
import { useSelectedPropertyStore } from '@/stores'
import { useAllProperties } from '@/hooks/useProperties'

/**
 * The building the dashboard shows (owner, 2026-10-05: the dashboard opens on
 * all buildings, like Reports, and keeps its own choice instead of following
 * the header's). DashboardPage owns the choice (its URL) and provides it here;
 * null means all buildings. Every widget on the dashboard reads it through
 * useDashboardPropertyId, so none of them follows the header there.
 *
 * Outside a provider the hook falls back to the header's selection, so a
 * component that also appears elsewhere keeps its old behaviour.
 */
export const DashboardPropertyContext = createContext<number | null | undefined>(undefined)

export function useDashboardPropertyId(): number | null {
  const scoped = useContext(DashboardPropertyContext)
  const header = useSelectedPropertyStore((s) => s.selectedPropertyId)
  return scoped === undefined ? header : scoped
}

/**
 * Meter readings are per building (the API has no all-buildings call). On
 * "all buildings" an account with a single building still gets its readings;
 * with several, a building has to be chosen, as before.
 */
export function useDashboardReadingsPropertyId(): number {
  const selected = useDashboardPropertyId()
  const { data: properties } = useAllProperties(selected == null)
  if (selected != null) return selected
  return properties?.length === 1 ? properties[0].id : 0
}
